$(function () {
  // MENU MOBILE
  $(".toggle-hem a").on("click", function (e) {
    e.preventDefault();
    $(".mobile-menu-wrapper, body").toggleClass("active-menu");
  });
  $(".menu-close-icon svg").on("click", function (e) {
    e.preventDefault();
    $(".mobile-menu-wrapper, body").toggleClass("active-menu");
  });
  $(".size-guide-pup").on("click", function (e) {
    e.preventDefault();
    $(".sizeguide-popup, body").addClass("active-size-popup");
  });
  $(".popup-overlay, .pdp-popup-close").on("click", function (e) {
    e.preventDefault();
    $(".sizeguide-popup, body").removeClass("active-size-popup");
  });

  $(".add-address-pop").on("click", function (e) {
    e.preventDefault();
    var cls = $(this).data('pop');
    if(cls != ''){
      $('.'+ cls +', body').addClass("active-popup");
    }
  });
  $(".pop-close, .overlay").on("click", function (e) {
    e.preventDefault();
    $(".add-popup, body").removeClass("active-popup");
  });

  $(".pr-info-ioc a, .cap-btns .explore-bt").on("click", function (e) {
    e.preventDefault();
    $(".pr-block-description, body").addClass("active-fc");
  });
  $(".popup-overlay, .pdp-popup-close").on("click", function (e) {
    e.preventDefault();
    $(".pr-block-description, body").removeClass("active-fc");
  });


  var cccn = 0;
  $(".popup-overlay, .pdp-popup-close").on("click", function (e) {
    e.preventDefault();
    $(".pr-features-popup").removeClass("active-fc");
    cccn = 0;
  });

  if($(window).width() > 768){
    $(".features_popups").on("mouseover", function (e) {
      e.preventDefault();
      var pop = $(this).data('pop');
      $('.pr-features-popup').removeClass("active-fc");
      $('.' + pop).addClass("active-fc");
    });
  }
  $(".features_popups").on("click", function (e) {
    e.preventDefault();
    var pop = $(this).data('pop');
    $('.pr-features-popup').removeClass("active-fc");
    $('.' + pop).addClass("active-fc");
    cccn++;
  });
  if($(window).width() > 768){
    $(".features_popups").closest('li').on("mouseleave", function (e) {
      e.preventDefault();
      if(cccn === 0){
        $('.pr-features-popup').removeClass("active-fc");
      }
    });
  }

  $('.openChat').on('click', function(r){
    r.preventDefault();
    if(typeof Hero === 'undefined') {

    } else {
       Hero.open();
    }
  })

  $(".live-chat-fix").click(function () {
    $(".concierge-popup").toggleClass('active-chat-box');
  });

  $('ul.sub-tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $(this).closest('.has_parent').find('ul.sub-tabs li').removeClass('current');
    $(this).closest('.has_parent').find('.tab-sub-content').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
  });
  /*tabs script end here*/
  if ($('#countdown').length > 0) {
    var endtime = $('#countdown').attr('data-endtime');
    // Set the date we're counting down to
    var countDownDate = new Date(endtime).getTime();
    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      // Output the result in an element with id="demo"
      document.getElementById("days").innerText = days,
        document.getElementById("hours").innerText = hours,
        document.getElementById("minutes").innerText = minutes,
        document.getElementById("seconds").innerText = seconds;
      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("event-timer").innerHTML = '<h3 class="farm-head-title">Times up</h3>';
        $('.event-wrapper .mail-box-btn').hide();
      }
    }, 1000);
  }
  // LIVE CHAT CLICK
  // flag : says "remove class when click reaches background"
  var removeClass = true;
  // when clicking the button : toggle the class, tell the background to leave it as is
  $(".live-chat-box, .close-icon").click(function () {
    $(".live-chat-popup").toggleClass('live-active');
    removeClass = false;
  });

  $('body').on('click','.store_search_submit',function(){  
    var _thiss = $(this);    
    if($(this).closest('.store-input').find('#store_input').val() != ''){
      $('.store-info.error_msg').hide();
      _thiss.closest('.store-details').find('.store-info.addresses').html('<img src="https://cdn.shopify.com/s/files/1/2532/9670/files/200.gif?v=1617094915" alt="loader" loading="lazy">');      
      var stval = $(this).closest('.store-input').find('#store_input').val().toLowerCase();
      $.get( "/pages/goorin-retail-locations", function(page_data) {
        var html;
        var storcnt = 0;
        $(page_data).find(".find-shop-item").filter(function() { 
          if($(this).find('.address-blog').text().toLowerCase().indexOf(stval) > -1){
            storcnt++;
            if(storcnt == 1){
              _thiss.closest('.store-details').find('.store-info.addresses').html('<div class="address"><div class="left_content">'+$(this).find('.address-blog').html()+'</div><div class="right_dir">'+$(this).find('.address-right .direction').html()+'</div></div>');          
            }else{
              _thiss.closest('.store-details').find('.store-info.addresses').append('<div class="address"><div class="left_content">'+$(this).find('.address-blog').html()+'</div><div class="right_dir">'+$(this).find('.address-right .direction').html()+'</div></div>');          
            }
          }        
        }); 
        if(storcnt == 0){
          $('.store-info.addresses').html('');
          $('.store-info.error_msg').show();
        }
      });
      $('.mobile-menu-bar ul').animate({
        scrollTop: $("#store_locator_title").offset().top
      }, 2000);
    }
  });
  
  $("body").on('click','.store-close-input button',function (e) {
    e.preventDefault();
    $(this).closest('.store-input-inner').find('input').val('');    
    $('.store-info.addresses').html('');
    $('.store-info.error_msg').hide();
  });

  $(".quick-add-mob a").click(function () {
    $(this).toggleClass("quick-active");
    $(this).closest(".product-card").find(".size_option").slideToggle();
  });

  $(".pdp-title-cart").click(function () {
    $(".pdp-title-cart").removeClass("active");
    $(".pdp-tab .content-cart").slideUp();
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
    }
  })

  $(".product-type-info a").click(function () {
    $(".product-type-info a").removeClass("active");
    $(".product-type-info ul").slideUp();
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
    }
  })

  if ($(window).width() <= 767) {
    $(".f-link-heading").click(function () {
      $(".f-link-heading").removeClass("active");
      $(".f-link ul").slideUp();
      if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
      }
    })
  }

  // NICE SELECT
  $('.nice-select').each(function () {
    var select = $(this),
        name = select.attr('name');
    select.hide();
    select.wrap('<div class="nice-select-wrap"></div>');
    var parent = select.parent('.nice-select-wrap');
    parent.append('<ul id=' + name + ' style="display:none"></ul>');
    select.find('option').each(function () {
      var option = $(this),
          value = option.attr('value'),
          label = option.text();
      if (option.is(":first-child")) {
        $('<a href="#" class="drop">' + label + '</a>').insertBefore(parent.find('ul'));
      } else {
        parent.find('ul').append('<li><a href="#" id="' + value + '">' + label + '</a></li>');
      }
    });
    parent.find('a').on('click', function (e) {
      parent.toggleClass('down').find('ul').slideToggle(300);
      e.preventDefault();
    });
    parent.find('ul a').on('click', function (e) {
      var niceOption = $(this),
          value = niceOption.attr('id'),
          text = niceOption.text();
      select.val(value);
      parent.find('.drop').text(text);
      e.preventDefault();
    });
  });

  $('body').on('click','.our-stylist .stylist-nav a',function(){
    var index = $(this).data('index');
    $('.our-stylist .video_brims_slider').slick('slickGoTo', parseInt(index));
  });

  const setProductPageLoading = () => {
    var hBeforeDestroy = null;
    if($('.product-img-slider').hasClass('slick-initialized')){
      hBeforeDestroy = $('.product-detail-wrapper .product-detail-inner .product-img-view .img-view-item img').css('height');
      $('.product-img-slider').slick('destroy');
      $('.product-img-slider').css('height','100%');
    }
    if (hBeforeDestroy!=null){
      $('.product-img-view .pdpimg_loader').css('height',hBeforeDestroy);
      $('.product-img-view .pdpimg_loader').css('width','100%');
    }
    $('.product-img-view .pdpimg_loader').css('display','block');
  }

  if($('.template-product').length > 0){
    var chand = $('body').data('currentproduct');
    var toAppendProduct = '';

    const putImages = (images) => {
      return new Promise((resolve,reject) => {
        $('.product-img-slider.new_custom_imgs').css('display','none');
        $('.product-img-slider.new_custom_imgs').empty();
        $('.product-img-slider.new_custom_imgs').append(images);
        let childreSize = $('.img-view-item').children().length;
        if (childreSize>0){
          resolve('exito' + childreSize);
        }else{
          reject('error' + childreSize);
        }
      })
    }
    const setImages = (product, fcolval, imgl) => {
      var code = colorcode(fcolval);
      if(product.images.length > 0){
        var imgs = product.media;
      }else{
        var imgs = product.images;
      }
      $('.product-image-zoom .pop_wrapper').empty();
      $('.product-image-zoom .pop_wrapper').append('<div class="zoom-pop-slider"></div>');

      if(imgs.length > 0){
        var imcnt = 0;
        // imgl == 0 we have swatch elements in the dom and to use color codes
        // imgl == 1 we don't have swatch elements and to skip color codes
        if(imgl == 0){
          var totlimg = 0;
          $(poscode).each(function(i,mv){
            var hasc = 0;
            $(imgs).each(function(i,iv){
              if(imcnt == 6){
                return false;
              }
              if(iv.media_type == "image"){
                var sr = iv.src;
                var newsrc = sr.replace(".jpg", "_776x776_crop_center.jpg").replace(".png", "_776x776_crop_center.png");
                var thumbSrc = sr.replace(".jpg", "_80x80_crop_center.jpg").replace(".png", "_80x80_crop_center.png");
                if(sr.includes(code)){
                  if(sr.includes(mv)){
                    totlimg++;
                    var cls = getclass(sr);
                    const altText = iv.alt ? iv.alt : getAltText({ title: product.title, type: product.type, view: cls, color: fcolval});
                    var imgClass='';
                    if (iv.aspect_ratio !== 1) imgClass='imgvar'
                    toAppendProduct+='<div class="img-view-item position_'+ cls +'" data-thumb="' + thumbSrc + '"><div class="prod-slide product-single-imgae"><a href="#" data-mediaindex="'+imcnt+'" data-pop="color_'+fcolval+'"><img src="'+ sr +'" class="'+imgClass+'" alt="'+ altText +'"><div class="product-pop-btn"><svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="PDP-Zoom-/-Image-Gallery" transform="translate(-419 -430)"><g id="Group-9" transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g id="Group-8" transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></a></div></div>';
                    $('.product-image-zoom .zoom-pop-slider').append('<div class="pop-slide-item"><div class="prod-slide product-single-imgae"><img src="'+ newsrc +'" alt="'+ altText +'" loading="lazy"></div></div>');

                    imcnt++;
                    var hasc = 1;
                  }
                }
                if(hasc == 1){
                  return false;
                }
              }else if(iv.media_type == "model"){
                var msr = iv.sources[0].url;
                var psr = iv.preview_image.src;
                var npsr = psr.replace(".jpg", "_776x776_crop_center.jpg").replace(".png", "_776x776_crop_center.png");
                var thumbSrc = psr.replace(".jpg", "_80x80_crop_center.jpg").replace(".png", "_80x80_crop_center.png");

                if(msr.includes(code)){
                  if(msr.includes(mv)){
                    totlimg++;
                    if(imcnt > 2){
                      // $('.product-img-slider.new_custom_imgs').addClass('has_more_media');
                    }
                    var cls = getclass(msr);
                    const altText = iv.alt ? iv.alt : getAltText({ title: product.title, type: product.type, view: cls, color: fcolval});
                    toAppendProduct+='<div class="img-view-item position_'+ cls +'" data-thumb="' + thumbSrc + '"><div class="prod-slide product-single__media img_3d" style="padding-top: 100%"><a href="#" data-mediaindex="'+imcnt+'" data-pop="color_'+fcolval+'"><model-viewer id="reveal" loading="eager" camera-controls auto-rotate  src="'+msr+'" camera-controls="true" data-shopify-feature="1.2" alt="'+ altText +'" poster="'+npsr+'" data-js-focus-visible="" ar-status="not-presenting"></model-viewer><div class="product-pop-btn"><svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="PDP-Zoom-/-Image-Gallery" transform="translate(-419 -430)"><g id="Group-9" transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g id="Group-8" transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></a></div></div>';
                    $('.product-image-zoom .zoom-pop-slider').append('<div class="pop-slide-item"><div class="prod-slide product-single__media img_3d" style="padding-top: 100%"><model-viewer camera-controls auto-rotate  src="'+msr+'" camera-controls="true" data-shopify-feature="1.2" alt="'+ altText +'" poster="'+npsr+'"></model-viewer></div></div>');

                    imcnt++;
                    var hasc = 1;
                  }
                }
                if(hasc == 1){
                  return false;
                }
              }

            });
          });
          if(totlimg == 0){
            $(imgs).each(function(i,iv){
              var sr = iv.src;
              var newsrc = sr.replace(".jpg", "_776x776_crop_center.jpg").replace(".png", "_776x776_crop_center.png");
              var thumbSrc = sr.replace(".jpg", "_80x80_crop_center.jpg").replace(".png", "_80x80_crop_center.png");


              if(i > 2){
                //$('.product-img-slider.new_custom_imgs').addClass('has_more_media');
              }
              var cls = getclass(sr);
              const altText = iv.alt ? iv.alt : getAltText({ title: product.title, type: product.type, view: cls, color: fcolval});
              toAppendProduct+='<div class="img-view-item position_'+ cls +'" data-thumb="' + thumbSrc + '"><div class="prod-slide product-single-imgae"><a href="#" data-mediaindex="'+i+'" data-pop="color_'+fcolval+'"><img src="'+ sr +'" class="" alt="'+ altText +'" loading="lazy"><div class="product-pop-btn"><svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="PDP-Zoom-/-Image-Gallery" transform="translate(-419 -430)"><g id="Group-9" transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g id="Group-8" transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></a></div></div>';
              $('.product-image-zoom .zoom-pop-slider').append('<div class="pop-slide-item"><div class="prod-slide product-single-imgae"><img src="'+ newsrc +'" alt="'+ altText +'" loading="lazy"></div></div>');
              if(i == 5){
                return false;
              }
            });
          }
        }else{
          $(imgs).each(function(i,iv){
            var sr = iv.src;
            var newsrc = sr.replace(".jpg", "_776x776_crop_center.jpg").replace(".png", "_776x776_crop_center.png");
            var thumbSrc = sr.replace(".jpg", "_80x80_crop_center.jpg").replace(".png", "_80x80_crop_center.png");

            if(i > 2){
              //$('.product-img-slider.new_custom_imgs').addClass('has_more_media');
            }
            var imgClass='';
            var cls = getclass(sr);
            if (product.type === 'Bundle'){
              cls= 'bundle';
              fcolval = 'bundle';
              imgClass = 'no-m-p'
            }
            const altText = iv.alt ? iv.alt : getAltText({ title: product.title, type: product.type, view: cls, color: fcolval});
            toAppendProduct+='<div class="img-view-item position_'+ cls +'" data-thumb="' + thumbSrc + '"><div class="prod-slide product-single-imgae"><a href="#" data-mediaindex="'+i+'" data-pop="color_'+fcolval+'"><img src="'+ sr +'" class="'+imgClass+'" alt="'+ altText +'" loading="lazy"><div class="product-pop-btn"><svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="PDP-Zoom-/-Image-Gallery" transform="translate(-419 -430)"><g id="Group-9" transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g id="Group-8" transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></a></div></div>';
            $('.product-image-zoom .zoom-pop-slider').append('<div class="pop-slide-item '+imgClass+'"><div class="prod-slide product-single-imgae"><img src="'+ newsrc +'" alt="'+ altText +'" loading="lazy"></div></div>');
            if(i == 5){
              return false;
            }
          });
        }
      }else{
        toAppendProduct+='<div class="img-view-item" data-thumb="' + thumbSrc + '"><div class="prod-slide product-single-imgae"><a href="#" data-mediaindex="1" data-pop="random"><img src="https://prismic-io.s3.amazonaws.com/goorin%2Fcea2d0aa-bdba-4a7b-a9fa-947ba28a98c4_wide-brim.svg?-F01-Ebony" class="" alt="placholder image" loading="lazy"><div class="product-pop-btn"><svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="PDP-Zoom-/-Image-Gallery" transform="translate(-419 -430)"><g id="Group-9" transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g id="Group-8" transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" id="Line-3" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></a></div></div>';
        $('.product-image-zoom .zoom-pop-slider').append('<div class="pop-slide-item"><div class="prod-slide product-single-imgae"><img src="https://cdn.shopify.com/s/files/1/2532/9670/files/wide-brim.svg?v=1617345112" alt="Placeholder image" loading="lazy"></div></div>');
      }
      if(imgs.length <= 1){
        $('.product-image-zoom .zoom-pop-slider').addClass('block_1');
      }

      if (toAppendProduct!=''){
        const prm = putImages(toAppendProduct);
        prm.then((children)=>{
          if (window.innerWidth > 640) {
            $('.product-img-view .pdpimg_loader').css('display','none');
            $('.product-img-slider.new_custom_imgs').css('opacity', 0);
            $('.product-img-slider.new_custom_imgs').css('display','grid');
          }
        }).catch((error)=>{
          console.error('img append error: '+error);
        }).finally(()=>{
          toAppendProduct='';
          $('.product-img-slider.new_custom_imgs').css('opacity', 1);
        });
      }
    };

    function append_imgs(fcolval,imgl,chand){
      const productUri = '/products/'+ chand + '.js';
      let cache = null;
      if (sessionStorage.getItem(productUri)) {
        try {
          cache = JSON.parse(sessionStorage.getItem(productUri));
        } catch {
          cache = null;
        }
      }

      if ( cache && cache.expiration > Date.now()) {
        setImages(cache.product, fcolval, imgl);
        if (window.innerWidth < 641) {
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
          }, 1500);
        }
      } else {
        $.getJSON(productUri, (product) => {
          sessionStorage.setItem(productUri, JSON.stringify({ product, expiration: Date.now() + (1000 * 60 * 10) }));
          setImages(product, fcolval, imgl);
          if ($(window).width() < 641) {
            setTimeout(() => {
              window.dispatchEvent(new Event('resize'));
            }, 1500);
          }
        });
      }

      if(window.innerWidth < 640){
        let executed = false;
        const setslide = () => {
          if($('.product-img-slider.new_custom_imgs').hasClass('slick-initialized') && $('.product-img-slider .img-view-item').length > 0 && !executed){
            $('.product-img-slider').slick('refresh');
            $('.product-img-slider.new_custom_imgs').removeAttr('style');
            executed = true;
          }else{
            setTimeout(function(){
              setslide();
            }, 200);
          }
        }
        // setslide();
      }
    }

    setProductPageLoading();
    function afteradd(){
      if($('body').hasClass('linked_done')){

        var imgl = 0;
        if($('.color-select .swatch .has_show.swatch-element.available:not(.soldout):eq(0)').length > 0){
          var fcolval = $('.color-select .swatch .has_show.swatch-element.available:not(.soldout):eq(0) input').val().toLowerCase();
        }else if($('.color-select .swatch .swatch-element.available:eq(0)').length > 0){
          var fcolval = $('.color-select .swatch .swatch-element.available:eq(0) input').val().toLowerCase();
        }else if($('.color-select .swatch .swatch-element').length > 0){
          var fcolval = $('.color-select .swatch .swatch-element:eq(0) input').val().toLowerCase();

        }else{
          var imgl = 1;
        }
        append_imgs(fcolval,imgl,chand);
      }else{
        setTimeout(function(){
          afteradd();
        },200);
      }
    }
    afteradd();

  }

   $('.product-all-details .option_Color').find('input:radio').on('change',function(){
    var val = $(this).val().toLowerCase();
    if($('.template-product').length > 0){
      setProductPageLoading();
      $('.product-image-zoom .zoom-pop-slider').empty();
      append_imgs(val,0,chand);
    }
  });

  $('body.template-product').on('click','.product-img-view .img-view-item a',function(e){
  	e.preventDefault();
    var index = $(this).attr('data-mediaindex');
    var pop = $(this).attr('data-pop');
    if($('.product-image-zoom').find('.zoom-pop-slider').hasClass('slick-initialized')){
      $('.product-image-zoom').find('.zoom-pop-slider').slick('refresh');
    }else{
      $('.zoom-pop-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        infinite: false,
        speed: 100,
        touchThreshold: 100,
        swipeToSlide: true,
        waitForAnimate: false,
        adaptiveHeight: false
      });
    }
    $('.product-image-zoom').find('.zoom-pop-slider').slick('slickGoTo', parseInt(index));
    $('.product-image-zoom').addClass('active-pop');
  });

  $('body').on('click','.zoom-pop-close',function(e){
    e.preventDefault();
    $(this).closest('.product-image-zoom').removeClass('active-pop');
  });


  if ($('.read_more').length > 0 ) {
    $(".read_more").hide();
    $(".moreless-button").on("click", function (e) {
      e.preventDefault();
      var txt = $(".read_more").is(':visible') ? 'READ MORE' : 'READ LESS';
      $(this).find('span').text(txt);
      if(!$(".read_more").is(':visible')){
        $(this).find('svg').css('transform','rotate(180deg)');
      }else{
        $(this).find('svg').css('transform','rotate(0)');
      }
      $(this).closest('.pr-fc-details').find('.read_more').slideToggle('slow');
    });
  }

  $('body').on('click','.fd-drop-video .mail-box-btn .singup_btn',function(e){
    e.preventDefault();
	$(this).closest('.mail-box-btn').addClass('input_active');
  });

  if($(".template-product .pdp-nifo").length > 0){
    $(".template-product .learn_more").on("click", function (e) {
      e.preventDefault();
      var nift = $(this).closest('.product-all-details').find('.pdp-nifo').offset().top - 50;
      if(!$('.pdp-nifo .description.pdp-tab:eq(0) h5').hasClass('active')){
        $('.pdp-nifo .description.pdp-tab:eq(0) h5').trigger('click');
      }
      $("html, body").animate({ scrollTop: nift }, 500);
    });
  }

  $('.product-all-details').on('click','.rv-btn a', function(e){
    e.preventDefault();
    if($('#stamped-main-widget').length > 0){
      var tot = $('#stamped-main-widget').offset().top - 50;
      $("html, body").animate({ scrollTop: tot }, 800);
    }
  });

  $('body').on('click','.afterpay-link',function(e){
    e.preventDefault();
    $('body').addClass('after_pop_active');
    $('#afterpay-modal-overlay').show();
  });

  $('body').on('click','#afterpay-modal-close',function(e){
    e.preventDefault();
    $('body').removeClass('after_pop_active');
    $('#afterpay-modal-overlay').hide();
  });

  $("body").on("click",'.core_classic_wrapper .cm-filter-main .filter-tag li a', function(e) {
    e.preventDefault();
    $('.core_classic_wrapper .product-card').show();
    $('.core_classic_wrapper .cm-filter-main .filter-tag').hide();
    $('.core_class_collection .no_matches').hide();
    $('.core_class_col-wrapper').removeClass('no_match');
  });

  $('body').on('click','.bck_to_last',function(e){
	e.preventDefault();
    var refe = $('.my-cart-wrapper .finish-look').data('coll');
    if(refe.indexOf('cart') > 0 || refe == ''){
    	window.location.href = '/collections/all';
    }else{
    	window.location.href = refe;
    }

  });

  $('a').each(function(i,v){
    var valh = $(this).attr('href');
    if(valh != null && valh != ''){
      if(valh.indexOf('https:') > -1 || valh.indexOf('http') > -1){
        if(valh.indexOf('https://www.goorin.com') == -1){
          $(this).attr('target','_blank');
        }
      }else{
        if(valh[0] != '/' && valh[0] != '#' && valh.indexOf('javascript') == -1){
        	$(this).attr('target','_blank');
        }
      }
    }
  });

  // Add smooth scrolling to all links
  var m = window.location.href;
  $('a[href*="#"]').on('click', function (e) {
    if(m.indexOf('#') > -1){
      e.preventDefault()
      var y = $(this).attr('href').split('#');
      var x = y[1];
      $('html, body').animate({
        scrollTop: $('.'+x).offset().top - 120,
      },500,'linear')
    }
  });

  $('body').on('click','.article_view_all',function(e){
  	e.preventDefault();
    $('.interview-items').slideDown();
    $('.page_paginate').slideDown();
  });

});

$(window).load(function() {
  var m = window.location.href;
  if(m.indexOf('#') > -1){
    var y = m.split('#');
    var x = y[1];
    if(x != ''){
      if($('.'+x).length > 0){
        var ofst = $('.'+x).offset().top - 120;
        $('html, body').animate({
          scrollTop: ofst
        },500,'linear')
      }
    }
  }
  $('.omg-order-tracking .omg-html-top+.omg-section').show();
});

function lineItemToHtml(item) {
    return `
    <div class="line_item">
      <span class="product_id">${item.product_id}</span>
      <span class="sku_id">${item.variant_id}</span>
      <span class="quantity">${item.quantity}</span>
      <span class="name">${item.title}</span>
      <span class="unit_price">${item.price}</span>
      <span class="price_currency_code">USD</span>
    </div>
  `
}
